module.exports = __webpack_public_path__ + "img/pic-company.17952216.png";